import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/site/Logo";

const LAST_UPDATE = "21 juin 2026";

export default function MentionsLegales() {
  return (
    <main
      data-testid="page-mentions-legales"
      className="relative font-body text-[#0F172A] bg-[#FAFAFA] min-h-screen"
    >
      <header className="border-b border-[#0B1027]/8 bg-white/80 backdrop-blur-sm sticky top-0 z-30">
        <div className="mx-auto max-w-5xl px-6 md:px-10 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="page-back-home"
            className="inline-flex items-center gap-3"
            aria-label="Retour à l'accueil"
          >
            <Logo size={36} />
            <span className="font-brand text-xl text-[#0B1027] font-medium tracking-tight uppercase">
              Numedia
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#0B1027]/70 hover:text-[#A855F7] transition-colors"
          >
            <ArrowLeft size={16} />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-3xl px-6 md:px-10 py-16 md:py-24">
        <span className="eyebrow text-aurora">— Mentions légales</span>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight font-medium text-[#0B1027] mt-5 leading-[1.05]">
          Informations{" "}
          <em className="not-italic italic font-light text-aurora">
            légales.
          </em>
        </h1>
        <p className="text-[#0F172A]/65 mt-4 text-sm">
          Dernière mise à jour : {LAST_UPDATE}
        </p>

        <div className="mt-12 space-y-10 text-[#0F172A]/85 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              1. Éditeur du site
            </h2>
            <ul className="space-y-2">
              <li>
                <strong>Nom :</strong> David Devos (ci-après « Numedia »)
              </li>
              <li>
                <strong>Statut :</strong>{" "}
                <span className="text-[#A855F7]">
                  [À COMPLÉTER — ex. : Indépendant en personne physique, SRL…]
                </span>
              </li>
              <li>
                <strong>Adresse du siège :</strong>{" "}
                <span className="text-[#A855F7]">
                  [À COMPLÉTER — adresse complète]
                </span>
              </li>
              <li>
                <strong>Numéro d'entreprise (BCE) :</strong>{" "}
                <span className="text-[#A855F7]">
                  [À COMPLÉTER — 10 chiffres, ex. 0700.123.456]
                </span>
              </li>
              <li>
                <strong>Numéro TVA :</strong>{" "}
                <span className="text-[#A855F7]">
                  [À COMPLÉTER — BE0xxxxxxxxx ou « non assujetti »]
                </span>
              </li>
              <li>
                <strong>Email :</strong>{" "}
                <a
                  href="mailto:contact@numedia.be"
                  className="text-[#A855F7] hover:underline font-medium"
                >
                  contact@numedia.be
                </a>
              </li>
              <li>
                <strong>Téléphone :</strong> +32 498 97 98 47
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              2. Directeur de la publication
            </h2>
            <p>David Devos, en sa qualité d'éditeur du site.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              3. Hébergement
            </h2>
            <p>Le site numedia.be est hébergé par :</p>
            <ul className="mt-4 space-y-2">
              <li>
                <strong>Emergent Labs Inc.</strong>
              </li>
              <li>San Francisco, Californie — États-Unis</li>
              <li>
                Site web :{" "}
                <a
                  href="https://emergent.sh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#A855F7] hover:underline font-medium"
                >
                  emergent.sh
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              4. Propriété intellectuelle
            </h2>
            <p>
              L'ensemble du contenu présent sur ce site (textes, images,
              photographies, logos, graphismes, vidéos, code source, structure
              et design) est protégé par le droit d'auteur et reste la
              propriété exclusive de Numedia / David Devos, sauf mention
              contraire (visuels clients, captures de projets livrés).
            </p>
            <p className="mt-4">
              Toute reproduction, représentation, modification, publication ou
              adaptation, totale ou partielle, sans accord écrit préalable, est
              strictement interdite et constitue une contrefaçon au sens des
              articles XI.165 et suivants du Code de droit économique belge.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              5. Crédits visuels
            </h2>
            <p>
              Les captures de réalisations présentées illustrent des projets
              livrés par Numedia avec l'accord des clients concernés. Les
              logos et marques mentionnés appartiennent à leurs propriétaires
              respectifs.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              6. Données personnelles
            </h2>
            <p>
              Les modalités de collecte et de traitement de vos données
              personnelles sont décrites en détail dans notre{" "}
              <Link
                to="/confidentialite"
                className="text-[#A855F7] hover:underline font-medium"
              >
                Politique de confidentialité
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              7. Responsabilité
            </h2>
            <p>
              Numedia s'efforce de fournir des informations exactes et à jour
              sur ce site. Cependant, des erreurs ou omissions peuvent
              subsister. Numedia ne saurait être tenu responsable de
              dommages directs ou indirects résultant de l'utilisation des
              informations présentes sur le site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#0B1027] font-medium tracking-tight mb-4">
              8. Droit applicable & juridiction
            </h2>
            <p>
              Le présent site est soumis au droit belge. Tout litige relatif
              à son utilisation relève de la compétence exclusive des
              tribunaux de l'arrondissement judiciaire du siège de Numedia.
            </p>
          </section>

          <section className="rounded-2xl bg-[#FEF3C7]/40 border border-[#F59E0B]/30 p-6">
            <h3 className="font-display text-lg font-medium text-[#92400E] mb-2">
              ⚠️ Page en cours de finalisation
            </h3>
            <p className="text-sm text-[#92400E]/90">
              Certaines informations légales (numéro BCE, TVA, adresse,
              statut juridique) sont en attente de finalisation et seront
              complétées dès l'enregistrement officiel de l'activité.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-[#0B1027]/10">
          <Link
            to="/"
            data-testid="page-back-home-bottom"
            className="inline-flex items-center gap-2 text-sm text-[#0B1027]/70 hover:text-[#A855F7] transition-colors"
          >
            <ArrowLeft size={16} />
            Retour à l'accueil
          </Link>
        </div>
      </article>
    </main>
  );
}
